export const GRID_AREA_NAME = 'name';
export const GRID_AREA_ACCOUNT = 'account';
export const GRID_AREA_ARROW = 'arrow';
export const GRID_AREA_AVATAR = 'avatar';
